import RegisteredEmails from '../../../elements/RegisteredEmails'
import React from 'react'
import { Col, Form, Input, Row } from 'antd'
import { strVal } from '../../../modules/Utils'
import { get } from 'lodash'
import GroupType from '../../../elements/Select/Employee/GroupTypeSelect'
import { compose } from 'recompose'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import { defaultFormItemLayout } from '../../../modules/FormItems'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import withSpinning from '../../../elements/HOC/withSpinning'
import { rules } from '../../../modules/FormItems'

const { TextArea } = Input

function GroupForm (props) {
  const { getFieldDecorator, getFieldValue } = props.form
  const { group } = props

  const StatusSelect = compose(
    withSelectFetch({
      dropdown: 'groups',
      name: 'status',
      cache: true,
    }),
    withSpinning,
    withSort,
  )(CustomSelect)

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={12}>
          <Form.Item label="Code" {...defaultFormItemLayout}>
            {getFieldDecorator('code', {
              initialValue: strVal(group, 'code'),
              rules: rules.input,
            })(<Input placeholder="Code"/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Status" {...defaultFormItemLayout}>
            {getFieldDecorator('status', {
              initialValue: get(group, 'status'),
              rules: rules.select,
            })(<StatusSelect/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Name" {...defaultFormItemLayout}>
            {getFieldDecorator('name', {
              initialValue: strVal(group, 'name'),
              rules: rules.input,
            })(<Input placeholder="Name"/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Type" {...defaultFormItemLayout}>
            {getFieldDecorator('type', {
              initialValue: get(group, 'type'),
              rules: rules.select,
            })(<GroupType/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Description" {...defaultFormItemLayout}>
            {getFieldDecorator('description', {
              initialValue: get(group, 'description'),
            })(<TextArea placeholder="Description" rows={4}/>)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Primary Email" {...defaultFormItemLayout}>
            {getFieldDecorator('email', {
              initialValue: get(group, 'email'),
            })(<Input placeholder="Email" rows={4}/>)}
          </Form.Item>
        </Col>
      </Row>

      <RegisteredEmails {...{ getFieldDecorator, getFieldValue, doc: group }} />
    </Form>
  )
}

export default Form.create()(GroupForm)
